import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  cleanResentOtp,
  cleanUp,
  cleanupOtp,
  cleanupVerifyNotif,
  getUserDetail,
  resendOTP,
  verifyOTP,
} from "../../../redux/Slice/authSlice";
import { ClipLoader } from "react-spinners";

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const forgetPW = useSelector((state) => state?.auth?.forgetpwEmail);
  const verifyDetail = useSelector((state) => state?.auth?.verifyDetail);
  const userInfo = useSelector((state) => state?.auth?.userDetail);
  const verifyStatus = useSelector((state) => state?.auth?.verifyStatus);
  const loginUserDetail = useSelector((state) => state?.auth?.loginDetail);
  const signupUserDetail = useSelector((state) => state?.auth?.signupEmail);
  const { resentOtpResp } = useSelector((state) => state?.auth);

  const [otp, setOtp] = useState("");
  const [otpErrMsg, setOtpErrMsg] = useState(false);

  const redBorder = {
    border: "1px solid #d32f2f",
  };

  const notify = (msg) => toast(`${msg}`);

  useEffect(() => {
    if (location.pathname === "/otp/signup") {
      if (verifyDetail?.success === true) {
        notify("Verification successful!");
        navigate("/login");
        // need to redirect on a doccument upload page
        // navigate("/uploads");

      }
    } else {
      if (verifyDetail?.success === true) {
        notify("Verification successful!");
        navigate("/resetpassword");
      }
    }
  }, [verifyDetail]);
  useEffect(() => {
    if (resentOtpResp?.success) {
      notify(resentOtpResp?.message);
      dispatch(cleanResentOtp());
    }
  }, [resentOtpResp]);

  const handleresendOtp = () => {
    if (location.pathname === "/otp/signup") {
      dispatch(
        resendOTP({
          email: signupUserDetail,
        })
      );
    } else {
      dispatch(
        resendOTP({
          email: forgetPW,
        })
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (location.pathname === "/otp/signup") {
      if (otp.length !== 4) {
        setOtpErrMsg(true);
      } else {
        dispatch(
          verifyOTP({
            otp: Number(otp),
            email: signupUserDetail,
          })
        );
      }
    } else {
      if (otp.length !== 4) {
        setOtpErrMsg(true);
      } else {
        dispatch(
          verifyOTP({
            otp: Number(otp),
            email: forgetPW,
          })
        );
        // navigate('/resetpassword')
        // notify()
      }
    }
  };

  useEffect(() => {
    return () => {
      dispatch(cleanupOtp());
      dispatch(cleanupVerifyNotif());
    };
  }, []);

  return (
    <div className="container-fluid px-0">
      <div className="slider_img ">
        <div className="row mx-0 z_999">
          <div className="col-lg-4 px-0">
            <div className="login-div mx-1">
              <h2 className="font accentColor">OTP Verification</h2>
              <p className="secondaryColor fs14 text-center my-4">
                Please enter the verification code here we just sent you on your
                email
              </p>
              <div className="mt-2">
                <div className="inputOTP">
                  <OtpInput
                    inputType="number"
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    renderSeparator={<span> </span>}
                    renderInput={(props) => (
                      <input {...props} inputMode="numeric" />
                    )}
                    inputStyle={otpErrMsg ? redBorder : null}
                  />
                </div>
                {verifyDetail?.success === false ? (
                  <p className="location-err otp-err">
                    {verifyDetail?.message}
                  </p>
                ) : null}

                {otpErrMsg ? (
                  <p className="location-err otp-err mt-1">
                    Enter Correct code
                  </p>
                ) : null}
                <p className="secondaryColor fs14 text-center my-4">
                  Haven't received the verification code?{" "}
                  <span
                    onClick={handleresendOtp}
                    className="accentColor pointor"
                  >
                    Resend
                  </span>
                </p>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="btn w-100 grid-class img-btn primaryColor"
                >
                  {verifyStatus === "pending" ? null : "Verify"}
                  <ClipLoader
                    loading={verifyStatus === "pending" ? true : false}
                    cssOverride={{ width: "25px", height: "25px" }}
                    color="#fff"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
